import {useParams} from 'react-router-dom'
import React from 'react';

import {SJPBReviewTerrainCom} from '../containers'
function SJPBReviewTerrainComPage() {
    console.log('shsohourn to star')
    let { id } = useParams();
    let svparams = { 'id': id}
    console.log('shsohourn to svparams 3', svparams)
    return (
        <SJPBReviewTerrainCom svparams= {svparams} />
    );
}
export default SJPBReviewTerrainComPage

/*
import {useParams} from 'react-router-dom'
import React, { useState } from 'react';

import {SVReviewTerrainCom} from '../containers'
function SJPBReviewTerrainComPage() {
    let { id } = useParams();
    let svparams = { 'id': id}
    return (
        <div>

        <p>
          SV SojournReviewContainerPage Component
        </p>
        <SVReviewTerrainCom svparams= {svparams} />
        </div>
    );
}
export default SJPBReviewTerrainComPage
*/